module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_cuadrada_marco_comida_53.c81a4c96.png";